import type { CollectibleId } from "@/services/collectibles";
import { type CollectionItemId } from "@/services/collection/item";
import type { CurrencyId } from "@/services/currencies";
import type { MarketplaceItem_Schema, MarketplaceItemId_Schema } from "@/services/marketplace/item/marketplaceItemSchema";
import type { ShippingMethodId } from "@/services/marketplace/shippingMethod";
import { type PriceNumeric } from "@/services/prices";
import type { z } from "zod";

export type MarketplaceItemId = z.infer<typeof MarketplaceItemId_Schema>;
export type MarketplaceItem = z.infer<typeof MarketplaceItem_Schema>;

export type MarketplaceItem_CreatedFromCollectible = MarketplaceItem & {
  collectible: {
    id: CollectibleId;
    name: string;
  };
};

export type MarketplaceItem_Api_UpdateData = {
  quantity: number;
  note: string;
  itemPrice: {
    id: number;
    priceAmountCents: number;
    priceCurrency: CurrencyId;
  };
  itemDelivery: {
    id: number;
    delivery: ShippingMethodId;
    numberPerDelivery: number;
  }[];
  collectionItemId: CollectionItemId;
};

export type MarketplaceItem_Api_CreationData = {
  quantity: number;
  note: string;
  itemPrice: {
    priceAmountCents: number;
    priceCurrency: CurrencyId;
  };
  itemDelivery: {
    delivery: ShippingMethodId;
    numberPerDelivery: number;
  }[];
  collectionItemId: CollectionItemId;
};

export type MarketplaceItem_FormModel = {
  quantity: number | undefined;
  description: string | undefined;
  price: PriceNumeric | undefined;
};

export type MarketplaceItem_ShippingSetup = Map<ShippingMethodId, number>;

export class MarketplaceItemNotFoundException extends Error {}
